/**
 * Application route paths configuration.
 * Defines all available routes in the application.
 */
export const ROUTE_PATHS = Object.freeze({
  CLAIMS: '/reclamos',
  NOT_FOUND: '*',
  ROOT: '/'
})
